import { Link } from "react-router-dom";
import { siteInfo } from "@/mocks/site";

const quickLinks = [
  { label: "首页", to: "/" },
  { label: "事件档案", to: "/events" },
  { label: "常见问题", to: "/faq" },
  { label: "关于我们", to: "/about" },
];

const categoryLinks = [
  { label: "娱乐事件", to: "/events?category=entertainment" },
  { label: "直播风波", to: "/events?category=livestream" },
  { label: "品牌代言", to: "/events?category=brand" },
  { label: "音乐现场", to: "/events?category=music" },
  { label: "影视剧组", to: "/events?category=film" },
];

export default function SiteFooter() {
  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 rounded-md bg-primary-500 text-background-50 flex items-center justify-center font-heading font-bold text-sm">
                131
              </span>
              <span className="font-heading text-xl font-bold text-foreground-950">吃瓜 · {siteInfo.tagline}</span>
            </div>
            <p className="mt-4 text-sm leading-7 text-foreground-500 max-w-md">{siteInfo.description}</p>
            <div className="mt-5 flex items-center gap-3">
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-accent-100 text-accent-300">
                <i className="ri-mail-line" />
              </span>
              <div className="text-sm">
                <p className="text-foreground-950 font-medium">线索与纠错</p>
                <a href={`mailto:${siteInfo.email}`} className="text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">
                  {siteInfo.email}
                </a>
              </div>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-950">
              <a href="#footer-nav" className="cursor-pointer">站内导航</a>
            </h4>
            <ul id="footer-nav" className="mt-4 space-y-3">
              {quickLinks.map((link) => (
                <li key={link.to}>
                  <Link to={link.to} className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-950">
              <a href="#footer-category" className="cursor-pointer">证据分类</a>
            </h4>
            <ul id="footer-category" className="mt-4 space-y-3">
              {categoryLinks.map((link) => (
                <li key={link.to}>
                  <Link to={link.to} className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 md:mt-14 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <p className="text-xs text-foreground-500">
            © {new Date().getFullYear()} {siteInfo.name} · 仅整理公开可见素材，不代表任何一方立场
          </p>
          <p className="text-xs text-foreground-500 max-w-xl">
            站内素材均来自公开渠道，若涉及您的权益需要更正或删除，请通过上方邮箱联系我们。
          </p>
        </div>
      </div>
    </footer>
  );
}